module.exports = __webpack_public_path__ + "static/media/ic_arrowRightGreen.f2da2aa8.svg";